import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import NbmModel from "@/models/produto/nbmModel";
import nbmService from "@/services/produto/nbmService";

import ListComponentBase from "../listComponentBase";

@Component
export default class NbmListComponent extends ListComponentBase<NbmModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("codigo", this.$t("__.ts.codigo"), GridColumnType.String),
            new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setPropsCached(nbmService, "nbm", "descricao");
    }
}
